import React,{useImperativeHandle, forwardRef, useState, useEffect,useRef} from 'react';
import { Modal, Form, Button } from 'antd';
import BaseForm from '@/components/baseForm/BaseForm';
import * as User from '@/common/api/user'
import JSEncrypt from 'jsencrypt'
function savePasswordInfo (props, ref) {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formItem,setFormItem] = useState({});
    const [rsaPublicKey,setRSAPublicKey] = useState('');
    const pwdForm = useRef()
    const getCodeIsStatus = (rule, value, callback) => {
        if (value === '' || value === undefined) {
            callback('请输入密码')
            return
        }
        const oldPassword = form.getFieldValue('newPwd')
        if (value.length >= oldPassword.length) {
            value === oldPassword ? callback() : callback('两次输入密码不一致'); return false;
        }
    }
    //item配置
    const [formList] = useState([
        {
            key:'oldPwd',
            label:'原密码',
            placeholder: '请输入原密码',
            rules: [
                {
                required: true,
                message: '原密码不能为空'
                }
            ],
            type:'INPUT_PASSWORD',
            colSpan:24,
            layout: {
                labelCol: {
                    span: 7
                },
                wrapperCol: {
                    span: 13
                }
            }
        },
        {
            key:'newPwd',
            label:'新密码',
            placeholder: '请输入新密码',
            rules: [
                {
                required: true,
                message: '新密码不能为空'
                }
            ],
            type:'INPUT_PASSWORD',
            colSpan:24,
            layout: {
                labelCol: {
                    span: 7
                },
                wrapperCol: {
                    span: 13
                }
            }
        },
        {
            key:'confPwd',
            label:'确认密码',
            placeholder: '确认密码不能为空',
            rules: [
                { validator: (rule, value, callback) => getCodeIsStatus(rule, value, callback) }
            ],
            type:'INPUT_PASSWORD',
            colSpan:24,
            layout: {
                labelCol: {
                    span: 7
                },
                wrapperCol: {
                    span: 13
                }
            }
        }
    ])
    // 表单显示
    useImperativeHandle(ref, () => ({
        showModal: ()=> {
            form.resetFields()
            setVisible(true);
            setFormItem({})
        }
    }))
    // 模态框关闭
    const handleCancel = () => {
        form.resetFields()
        setVisible(false)
    }
    // 表单提交事件
    const handleSubmit = () => {
        form.validateFields().then((values) => {
            setLoading(true)
            const params = {...values}
            let encryptor = new JSEncrypt()
            encryptor.setPublicKey(rsaPublicKey)
            params.oldPwd = encryptor.encrypt( params.oldPwd)
            params.newPwd = encryptor.encrypt( params.newPwd)
            params.confPwd = encryptor.encrypt( params.confPwd)
            User.updatePassword(params).then(res => {
                if(res.code === 0){
                    React.$message.success('修改成功')
                    window.location.href = '/login'
                }
            }).finally(() => {
                setLoading(false)
            })
        })
    }
    // 模态框底部按钮
    const modalButton = [
        <Button key="submits" loading={loading} onClick={handleSubmit} type="primary">保存</Button>,
        <Button key="back" onClick={handleCancel}>取消</Button>
    ]
    // 模态框配置项
    const modalOptions = {
        width: 500,
        footer: modalButton,
        onCancel: handleCancel,
        title: '修改密码',
        visible: visible
    }
    // 获取RSA公钥
    const handleRSAPublicKey = () => {
        User.getRsaPublicKey().then(res => {
            if(res.code === 0){
                setRSAPublicKey(res.data)
            }
        })
    }
    useEffect(() => {
        if(visible){
            handleRSAPublicKey()
        }
        if(pwdForm.current){
            pwdForm.current.initFormList()
        }
    }, [visible])
    return (
        <Modal {...modalOptions}>
        <BaseForm form={form} formList={formList} ref={pwdForm}/>
    </Modal>
    )
}
export default forwardRef(savePasswordInfo)